export default "__VITE_ASSET__Ce$n6lzj__"